import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {ReferralLeadsComponent} from './referral-leads.component';

const routes: Routes = [
    {path: 'referral-leads', component: ReferralLeadsComponent}
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class ReferralLeadsRoutingModule {
}
